import { Stack } from "expo-router";

/**
 * Admin stack layout within tabs
 */
export default function AdminTabLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}

